"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbsoluteFillStyle = void 0;
Object.defineProperty(exports, "CHECK_IN_CATEGORY", {
  enumerable: true,
  get: function get() {
    return _utils.CHECK_IN_CATEGORY;
  }
});
exports.isWindows = exports.isWeb = exports.isMacOS = exports.isIOS = exports.isAndroid = exports.ScreenWidth = exports.ScreenHeight = exports.ScreenDimensions = exports.ISO_DATE_FORMAT_STRING = exports.FullScreenStyle = exports.FullScreenImageStyle = void 0;
var _reactNative = require("react-native");
var _utils = require("@wellth/utils");
var _Dimensions$get = _reactNative.Dimensions.get("window"),
  width = _Dimensions$get.width,
  height = _Dimensions$get.height;
var ScreenWidth = exports.ScreenWidth = width;
var ScreenHeight = exports.ScreenHeight = height;
var ScreenDimensions = exports.ScreenDimensions = {
  width: width,
  height: height
};
var FullScreenImageStyle = exports.FullScreenImageStyle = {
  position: "absolute",
  width: width,
  height: height
};
var FullScreenStyle = exports.FullScreenStyle = FullScreenImageStyle;
var AbsoluteFillStyle = exports.AbsoluteFillStyle = _reactNative.StyleSheet.absoluteFillObject;
var ISO_DATE_FORMAT_STRING = exports.ISO_DATE_FORMAT_STRING = "YYYY-MM-DD";
var isAndroid = exports.isAndroid = _reactNative.Platform.OS === "android";
var isIOS = exports.isIOS = _reactNative.Platform.OS === "ios";
var isMacOS = exports.isMacOS = _reactNative.Platform.OS === "macos";
var isWeb = exports.isWeb = _reactNative.Platform.OS === "web";
var isWindows = exports.isWindows = _reactNative.Platform.OS === "windows";